import { beSMTPPlusGetMessagesTotalQueued } from 'Api/beSMTPPlusApi'
import { beSendGoGetEmailMessages } from 'Api/beSendGoApi'
import {
  STORE_KEY_ACCOUNT,
  STORE_KEY_LIST,
  storeGet
} from 'mailup-react-helpers'

import { fromUTCtoZoneFormatted, zones } from 'Helpers/dates'

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(duration)

export async function fetchSendings() {
  const { IdList, TimeZoneCode } = storeGet(STORE_KEY_LIST)
  const { IsSendMethodTypeFrequency, Bandwidth } = storeGet(STORE_KEY_ACCOUNT)

  const tz = zones[TimeZoneCode]

  const dateFrom = dayjs(Date.now(), tz)
    .set('hours', 0)
    .set('minutes', 0)
    .set('seconds', 0)

  const [{ TotalCount, TotalBytes }, { Items, TotalItems }] = await Promise.all(
    [
      beSMTPPlusGetMessagesTotalQueued(),
      beSendGoGetEmailMessages(
        IdList,
        { pageNum: 0, pageSize: 0 },
        {
          Origins: ['SmtpPlus'],
          DateFrom: dateFrom.toISOString()
        }
      )
    ]
  )

  const estimated =
    IsSendMethodTypeFrequency && Bandwidth > 0
      ? (TotalCount / Bandwidth) * 60
      : TotalBytes / 1024 / Bandwidth

  return {
    estimated,
    totalCount: TotalCount,
    totalSent: TotalItems,
    dateFromFormatted: fromUTCtoZoneFormatted(
      dateFrom.toISOString(),
      TimeZoneCode,
      'YYYY-MM-DDTHH:mmZ'
    )
  }
}
